export const currentYear = () => new Date().getFullYear();



// WEBPACK FOOTER //
// ./src/utils/date-util.js